import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash" }, null, -1)
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Êtes vous sûr(e) de vouloir supprimer la question numéro ")
const _hoisted_5 = { class: "badge badge-secondary font-weight-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_7 = { class: "p-4 rounded bg-light font-italic font-weight-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Annuler ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Supprimer ")

import ActionDialog, { type ActionProps } from "@/components/ActionDialog.vue";
import axios from '@/api';
import Button from "primevue/button";
import { ref } from 'vue';
import { type Question } from '@/types';
import { useAlert } from "@/composables/alert";

interface QuestionDeleteProps extends ActionProps {
    question: Question;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    question: null,
    campaignId: null
  },
  emits: ["remove"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    question: Question;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





const isOpen = ref(false);
const alert = useAlert();

function deleteQuestion(): void {
    axios
        .delete(`/questions/${props.question.uuid}`)
        .then(() => {
            alert.value = {
                status: 'success',
                summary: 'La question a été supprimée avec succès'
            };
        })
        .catch(({ response }) => {
            alert.value = {
                status: (409 === response.status) ? 'conflict' : 'error',
                detail: (409 === response.status) ? response.data['hydra:description'] : undefined
            };
        });
}

function onClose() {
    if (alert.value && alert.value.status === 'success') {
        emit('remove');
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(deleteQuestion, ["prevent"]),
    class: "d-flex justify-content-end"
  }, [
    _createVNode(_unref(Button), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => {isOpen.value = true;}),
      class: "align-middle p-button-text",
      "aria-haspopup": "dialog"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, "Remove question " + _toDisplayString(__props.question.ordinal), 1)
      ]),
      _: 1
    }),
    _createVNode(ActionDialog, {
      visible: isOpen.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event)),
      alert: _unref(alert),
      header: "Attention",
      "campaign-id": props.campaignId,
      onHide: onClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => {isOpen.value = false;}),
          class: "p-confirm-dialog-reject p-button-secondary p-button-outlined"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "submit",
          class: "p-button-danger",
          autofocus: ""
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.question.ordinal), 1),
          _hoisted_6
        ]),
        _createElementVNode("p", _hoisted_7, " “" + _toDisplayString(__props.question.title) + "” ", 1)
      ]),
      _: 1
    }, 8, ["visible", "alert", "campaign-id"])
  ], 40, _hoisted_1))
}
}

})